import FieldDropdown from "../dropdown/dropdown";
import FieldConfig from "../../proto/field-config";
import Department from "../../../model2/department/department";


export default class FieldDepartment extends FieldDropdown {

    constructor(config:FieldConfig) {

        super(config);
        this.typeLabel               = "Department"
        this.icon                    = 'i5-departments'
        this.isSearchable            = true

        this.noValueOptionLabel      = _.get(config,'noValueOptionLabel','Not departments')

        if (!config.options || config.options.length < 1) {
            // In shared view we don't have all users gd.users ... so need filter
            this.options = []

            // why not to options ?
            gd.session.departments.models.map((d:Department)=> {
                if (d.id) {
                    this.options!.push({
                        value: d.id,
                        label: d.name,
                        icon: "i5-departments"
                    })
                }
            })



        }

        this.classes = _.assign(this.classes, {
            PopoverMenu                 : 'min-w-200',
            PopoverMenuScrollContainer  : 'max-h-300',
        })

    }
}
